import React from "react";

//Component===============================
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import FormLabel from "@material-ui/core/FormLabel";
import TextField from '@material-ui/core/TextField';
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

//ICON ===============================
import SaveIcon from "@material-ui/icons/Save";
import PriorityHighIcon from "@material-ui/icons/PriorityHigh";

import ConfigHost from "ConfigHost"
import {thaiBath} from "ConvertFormat"
// import { API } from "API"
import { APIGet,APIPost } from "APIRequest"
import UrlServer from "UrlServer"
import * as Alert from "alertService"

//Style===============================
import withStyles from "@material-ui/core/styles/withStyles";
// import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const styles = {
    ...regularFormsStyle,
    container2: {
        paddingLeft: 16,
        paddingRight: 16,
        display: 'flex',
        flexWrap: 'wrap',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    dense: {
      marginTop: 16,
    },
    mt16: {
      marginTop: 16,
    },
    mt20: {
      marginTop: 20,
    },
    menu: {
      width: 200,
    },
    marginRight: {
        float: "right !important"
    },
}
class SetConfigDashboardPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          lists_header_periodintime:this.getDefaultPeriodintime(),
          picked_header_periodintime:0,

        //   lists_chart1_limit_topscore:[
        //       {
        //           code:"10",
        //           text:"10 อันดับแรก"
        //       },
        //       {
        //           code:"16",
        //           text:"16 อันดับแรก"
        //       },
        //       {
        //           code:"20",
        //           text:"20 อันดับแรก"
        //       }
        //   ],
          picked_chart1_limit_topscore:10,
          lists_chart1_duration:this.getDefaultDuration(),
          picked_chart1_duration:0,

          lists_chart2_periodintime:this.getDefaultPeriodintime(),
          picked_chart2_periodintime:0,
          lists_chart2_duration:this.getDefaultDuration(),
          picked_chart2_duration:0,

          lists_chart3_periodintime:this.getDefaultPeriodintime(),
          picked_chart3_periodintime:0,
          lists_chart3_duration:this.getDefaultDuration(),
          picked_chart3_duration:0,

          tokenLists:[],
          tokenID:0,
          detail:"",
        }
      }
    componentDidMount(){
        Alert.Loading()
        // API("GET",UrlServer.URL_GET_LISTS_MONITOR_TOKEN,null,({datas})=>{
        APIGet(UrlServer.URL_GET_LISTS_MONITOR_TOKEN,({datas})=>{
            this.setState({tokenLists:datas},()=>{
                Alert.LoadingClose()
            })
        })
    }
    handleChangeNameVal = event => {
        // console.log(">>>>> " + event.target.name , event.target.value );
        this.setState({
            [event.target.name]: event.target.value,
        },()=>{
            console.log(" >>>>> " + event.target.name, event.target.value );
        });
    };
    getDefaultDuration = ()=>{
        return [
            {
                code:1,
                text:"1 วินาที"
            },
            {
                code:3,
                text:"3 วินาที"
            },
            {
                code:5,
                text:"5 วินาที"
            },
            {
                code:10,
                text:"10 วินาที"
            },
            {
                code:20,
                text:"20 วินาที"
            },
            {
                code:60,
                text:"1 นาที"
            },
            {
                code:180,
                text:"3 นาที"
            },
            {
                code:300,
                text:"5 นาที"
            },
            {
                code:600,
                text:"10 นาที"
            }
        ]
    }
    getDefaultPeriodintime = ()=>{
        return [
            {
                code:"0",
                text:"รวมทั้งปี",
            },
            {
                code:"1",
                text:"ไตรมาตร ที่ 1 (มกราคม - มีนาคม)",
            },
            {
                code:"2",
                text:"ไตรมาตร ที่ 2 (เมษายน - มิถุนายน)",
            },
            {
                code:"3",
                text:"ไตรมาตร ที่ 3 (กรกฎาคม - กันยายน)",
            },
            {
                code:"4",
                text:"ไตรมาตร ที่ 4 (ตุลาคม - ธันวาคม)",
            },
            {
                code:"m1",
                text:"มกราคม",
            },
            {
                code:"m2",
                text:"กุมภาพันธ์",
            },
            {
                code:"m3",
                text:"มีนาคม",
            },
            {
                code:"m4",
                text:"เมษายน",
            },
            {
                code:"m5",
                text:"พฤษภาคม",
            },
            {
                code:"m6",
                text:"มิถุนายน",
            },
            {
                code:"m7",
                text:"กรกฎาคม",
            },
            {
                code:"m8",
                text:"สิงหาคม",
            },
            {
                code:"m9",
                text:"กันยายน",
            },
            {
                code:"m10",
                text:"ตุลาคม",
            },
            {
                code:"m11",
                text:"พฤศจิกายน",
            },
            {
                code:"m12",
                text:"ธันวาคม",
            },
        ]
    }
    
    openNewtab = ()=>{

        if( 
            this.state.tokenID === 0 ||
            this.state.picked_header_periodintime === 0 ||
            // this.state.picked_chart1_limit_topscore === 0 ||
            this.state.picked_chart1_duration === 0 ||
            this.state.picked_chart2_periodintime === 0 ||
            this.state.picked_chart2_duration === 0 ||
            this.state.picked_chart3_periodintime === 0 ||
            this.state.picked_chart3_duration === 0
        ){
           Alert.WarningCallback("เลือกให้ครบก่อน")
           return
        }
        Alert.Loading(true)
        // API("OPTIONS",URL.URL_SET_CONFIGS+this.state.tokenID,{
        APIPost(URL.URL_SET_CONFIGS+this.state.tokenID,{
            headerTotalScorePeriodInTime:this.state.picked_header_periodintime,
            chart1TopScoreLimit:this.state.picked_chart1_limit_topscore,
            chart1TopScoreDuration:this.state.picked_chart1_duration,
            chart2LeadScorePeriodInTime:this.state.picked_chart2_periodintime,
            chart2LeadScoreDuration:this.state.picked_chart2_duration,
            chart3AllScorePeriodInTime:this.state.picked_chart3_periodintime,
            chart3AllScoreDuration:this.state.picked_chart3_duration,
            detail:this.state.detail,
        },({datas})=>{
            
        })
    }
    
    handleChangeName = event => {
        console.log("handleChangeName >>>> ",event.target.name,event.target.value );
        this.setState({ 
            [event.target.name]: event.target.value ,
            dataWaitToSave:false
        },()=>{
            if(this.state.tokenID !== 0)
                this.getDatasSelect(event.target.value)
        });
    };

    getDatasSelect = (tokenID) => {
        Alert.Loading()
        APIGet(URL.URL_GET_CONFIGS+tokenID,({datas})=>{
            console.log("getDatasSelect >>>> ",datas.detail)
            this.setState({
                picked_header_periodintime:datas.headerTotalScorePeriodInTime,
                picked_chart1_limit_topscore:datas.chart1TopScoreLimit,
                picked_chart1_duration:datas.chart1TopScoreDuration,
                picked_chart2_periodintime:datas.chart2LeadScorePeriodInTime,
                picked_chart2_duration:datas.chart2LeadScoreDuration,
                picked_chart3_periodintime:datas.chart3AllScorePeriodInTime,
                picked_chart3_duration:datas.chart3AllScoreDuration,
                detail:datas.detail
            },()=>{
                Alert.LoadingClose()
            })
        })
    }

    renderTokenLists = ()=> {
        return this.state.tokenLists.map((data,index)=>{
            return  <MenuItem
                        key = {data.id+"-"+data.token}
                        classes={{
                            root: this.props.classes.selectMenuItem,
                            selected: this.props.classes.selectMenuItemSelected
                        }}
                            value={data.token}
                        >
                        {"Token : " + data.token }
                    </MenuItem>
        })
    }
    render() {
        const { classes } = this.props;
        var renderListsSelection = (datas)=> {
            return datas.map((data,index)=>{
                return  <MenuItem
                            key = {data.text+"-"+index}
                            classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected
                            }}
                            value={data.code}
                            >
                            {data.text}
                        </MenuItem>
            })
        }
        var renderSelection = (configsObj)=> {
            return  <GridItem xs={12}>
                        <FormControl
                        fullWidth
                        className={classes.selectFormControl+" "+classes.mt20}
                        >
                        <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                        >
                            {configsObj.title}
                        </InputLabel>
                        <Select
                            MenuProps={{
                                className: classes.selectMenu
                            }}
                            classes={{
                                select: classes.select
                            }}
                            value={(this.state[configsObj.pointerStateName] !==0 ? this.state[configsObj.pointerStateName]:"")}
                            onChange={this.handleChangeNameVal}
                            inputProps={{
                                name: configsObj.pointerStateName
                            }}
                        >
                            <MenuItem
                            disabled
                            classes={{
                                root: classes.selectMenuItem
                            }}
                            >
                                เลือก...
                            </MenuItem>
                            {renderListsSelection(configsObj.listsData)}
                        </Select>
                        </FormControl>
                    </GridItem>
        }
        return (
            <div className={classes.container2 + " fullWidth"}>
                <Card>
                    <CardBody>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12}>
                                <h4>ตั้งค่าในการแสดง Dashboard</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12}>
                                <div className={"scoll65-page"}>
                                    <GridContainer>
                                        <GridItem xs={12}>
                                            <FormControl
                                            fullWidth
                                            className={classes.selectFormControl}
                                            >
                                            <InputLabel
                                                htmlFor="simple-select"
                                                className={classes.selectLabel}
                                            >
                                                เลือก Token
                                            </InputLabel>
                                            <Select
                                                MenuProps={{
                                                    className: classes.selectMenu
                                                }}
                                                classes={{
                                                    select: classes.select
                                                }}
                                                value={(this.state.tokenID !== 0 ? this.state.tokenID : "")}
                                                onChange={this.handleChangeName}
                                                inputProps={{
                                                    name: "tokenID"
                                                }}
                                            >
                                                <MenuItem
                                                disabled
                                                classes={{
                                                    root: classes.selectMenuItem
                                                }}
                                                >
                                                    เลือก...
                                                </MenuItem>
                                                {this.renderTokenLists()}
                                            </Select>
                                            </FormControl>
                                        </GridItem>
                                        <GridItem xs={12} sm={1}>
                                            <FormLabel className={classes.labelHorizontal}>
                                                คำอธิบาย
                                            </FormLabel>
                                        </GridItem>
                                        <GridItem xs={12} sm={11}>
                                            <CustomInput
                                                id="help-text"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    type: "text",
                                                    name: "detail",
                                                    onChange:this.handleChangeName,
                                                    value:this.state.detail
                                                }}
                                                // onChange={this.handleChangeName}
                                                helpText="อธิบายว่า Token นี้เป็นของที่ไหน เพื่ออะไร..."
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer>
                                    {/* sm={6} md={6} lg={6} */}
                                        {renderSelection({
                                            title:"(Total on header) เลือกช่วงเวลาที่ต้องการรวมยอดด้านบนขวาใน Dashboard",
                                            listsData:this.state.lists_header_periodintime,
                                            pointerStateName:"picked_header_periodintime"
                                        })}
                                        {/* {renderSelection({
                                            title:"(Chart 1 หน้าแสดง TSR ทำยอดสูงสุดประจำวัน) เลือกจำนวนการแสดง TSR ที่ทำยอดสูงสุดตามลำดับ",
                                            listsData:this.state.lists_chart1_limit_topscore,
                                            pointerStateName:"picked_chart1_limit_topscore"
                                        })} */}
                                        {renderSelection({
                                            title:"(Chart 1) เลือกระยะเวลาในการแสดงของ Chart 1",
                                            listsData:this.state.lists_chart1_duration,
                                            pointerStateName:"picked_chart1_duration"
                                        })}
                                        {renderSelection({
                                            title:"(Chart 2 หน้าแสดงยอดของ Supervisor) เลือกช่วงเวลาที่ต้องการรวมยอดของ Chart 2",
                                            listsData:this.state.lists_chart2_periodintime,
                                            pointerStateName:"picked_chart2_periodintime"
                                        })}
                                        {renderSelection({
                                            title:"(Chart 2) เลือกระยะเวลาในการแสดงของ Chart 2",
                                            listsData:this.state.lists_chart2_duration,
                                            pointerStateName:"picked_chart2_duration"
                                        })}
                                        {renderSelection({
                                            title:"(Chart 3 หน้าแสดงยอดของ TSR ทุกคน) เลือกช่วงเวลาที่ต้องการรวมยอดของ Chart 3",
                                            listsData:this.state.lists_chart3_periodintime,
                                            pointerStateName:"picked_chart3_periodintime"
                                        })}
                                        {renderSelection({
                                            title:"(Chart 3) เลือกระยะเวลาในการแสดงของ Chart 3",
                                            listsData:this.state.lists_chart3_duration,
                                            pointerStateName:"picked_chart3_duration"
                                        })}
                                    </GridContainer>
                                </div>
                            </GridItem>
                            <GridItem xs={12}>
                                <br/>
                                <Button color="info" size="sm" onClick={(e)=>this.openNewtab()}>
                                    <SaveIcon className={classes.icons} /> บันทึกค่า
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default withStyles(styles)(SetConfigDashboardPage);
